import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles = makeStyles({
  button: {
    display: 'flex',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    height: 18,
    font: 'inherit',
    borderRadius: 3,
    '&:hover, &:focus-visible': { backgroundColor: 'rgba(0, 0, 0, 0.06)' },
  },
  name: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  arrow: { fontSize: 16, flexShrink: 0 },
});

// Fits in the existing engine-name row, including when analysis is off.
export default function EngineSelector({ name, selectedEngine, anchorEl, onOpen, onClose, onSelect }) {
  const classes = useStyles();
  const selectedName = selectedEngine === 'nnue' ? 'Stockfish NNUE' : 'Stockfish';
  const description = name === selectedName
    ? `Choose engine: ${name}`
    : `Choose engine. Selected: ${selectedName}. Currently using: ${name}.`;

  return (
    <>
      <ButtonBase
        className={classes.button}
        aria-label={description}
        title={description}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        aria-controls={anchorEl ? 'engine-selection-menu' : undefined}
        onClick={onOpen}
      >
        <span className={classes.name}>{name}</span>
        <ArrowDropDownIcon className={classes.arrow} />
      </ButtonBase>
      <Menu
        id="engine-selection-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        MenuListProps={{ 'aria-label': 'Analysis engine' }}
      >
        <MenuItem
          role="menuitemradio"
          aria-checked={selectedEngine === 'classic'}
          selected={selectedEngine === 'classic'}
          onClick={() => onSelect('classic')}
        >Classic</MenuItem>
        <MenuItem
          role="menuitemradio"
          aria-checked={selectedEngine === 'nnue'}
          selected={selectedEngine === 'nnue'}
          onClick={() => onSelect('nnue')}
        >NNUE</MenuItem>
      </Menu>
    </>
  );
}
